import { SearchResponse } from '@/types'
import SearchTemplatePage from '@/components/SearchTemplatePage'
import { searchProducts } from '@/pages/api/search'
import { withSessionSsr } from '@/config/withSession'

export default function SearchPage(searchResponse: SearchResponse) {
  return <SearchTemplatePage searchResponse={searchResponse} />
}

export const getServerSideProps = withSessionSsr(async ({ req, query }: any) => {
  try {
    const { products, suggestions } = await searchProducts({
      query: query.part1,
      lang: query.lang,
      host: req.headers.host,
      agentId: req.session.agentConfiguration.agentId,
    })
    return {
      props: {
        products: products,
        suggestions: suggestions,
        loading: false,
      },
    }
  } catch (error) {
    console.error('error fetch', error)
    return { props: { error: true, loading: false } }
  }
})
